import React, { useCallback, useMemo } from 'react'
import clsx from 'clsx'
import useStyles from './styles'
import BoardColumn from './BoardColumn'
import { DragDropContext } from "react-beautiful-dnd"

const ColumnDivider = React.memo(() => {
  const classes = useStyles()
  return <div className={classes.boardColumnDivider} />
})

export const Board = React.memo((props) => {
  const { columns, items, cardFields, renderCardItem, skeleton, isFetching, onMoveItem, onCardClick, onItemSelect, isItemSelected } = props

  const classes = useStyles()

  const getColumnItems = useCallback((col) => {
    if (col.getItems) {
      return col.getItems(items)
    }
    return items.filter(item => item.key === col.key)
  }, [items])

  const getColumnSkeleton = useCallback((col) => {
    if (col.getSkeleton) {
      return col.getSkeleton()
    }

    return isFetching ? 3 : 0
  }, [isFetching])

  const getSelectedIndexItems = useCallback((col) => {
    if (col.getSelectedIndex) {
      return col.getSelectedIndex(getColumnItems(col))
    }

    return -1
  }, [getColumnItems])

  const onDragTaskStart = (item) => {
  }

  const onDragTaskEnd = useCallback((result) => {
    // alert("onDragTaskEnd: " + JSON.stringify(result, null, 2))

    if (!onMoveItem)
      return

    if (!result.destination || (
      result.source.droppableId === result.destination.droppableId &&
      result.source.index === result.destination.index
    ))
      return

    const sourceCol = columns.find(col => col.droppableId === result.source.droppableId)
    const destCol = columns.find(col => col.droppableId === result.destination.droppableId)

    const item = sourceCol.getItems(items)[result.source.index]

    onMoveItem(item, sourceCol, result.source.index, destCol, result.destination.index)
  }, [onMoveItem, columns, items])

  /** new renderColumns */
  const renderColumns = useMemo(() => {
    const result = []

    columns.forEach((col, index) => {
      if (index > 0) {
        result.push(<ColumnDivider key={`divider-${col.droppableId || col.key}`} />)
      }

      result.push(
        <BoardColumn
          key={col.droppableId || col.key}
          {...col}
          skeleton={getColumnSkeleton(col)}
          onCardClick={onCardClick}
          items={getColumnItems(col)}
          cardFields={cardFields}
          renderCardItem={renderCardItem}
          selectedIndex={getSelectedIndexItems(col)}
        />
      )
    })

    return result
  }, [
    columns,
    cardFields,
    renderCardItem,
    onCardClick,
    getColumnSkeleton,
    getColumnItems,
    getSelectedIndexItems,
  ])

  /** old legacy renderColumns */
  // const renderColumns = React.useMemo(() => {
  //   return columns
  //     .map(col =>
  //       <BoardColumn
  //         key={col.droppableId || col.key}
  //         {...col}
  //         skeleton={getColumnSkeleton(col)}
  //         onCardClick={onCardClick}
  //         items={getColumnItems(col)}
  //         cardFields={cardFields}
  //         renderCardItem={renderCardItem}
  //         selectedIndex={getSelectedIndexItems(col)}
  //       // listMode="virtual"
  //       />
  //     )
  //     .reduce((p, n) => p ? [...p, <div key={`divider-${n.key}`} className={classes.boardColumnDivider} />, n] : [n]
  //       , null)
  // }, [
  //   columns,
  //   cardFields,
  //   renderCardItem,
  //   onCardClick,
  //   classes.boardColumnDivider,
  //   getColumnSkeleton,
  //   getColumnItems,
  //   getSelectedIndexItems,
  // ])

  return (
    <DragDropContext onDragStart={onDragTaskStart} onDragEnd={onDragTaskEnd}>
      <div className={clsx(classes.board)}>
        {renderColumns}
      </div>
    </DragDropContext>
  )
}, (prev, next) => {
  return (
    prev.items === next.items &&
    prev.columns === next.columns &&
    prev.cardFields === next.cardFields &&
    prev.isFetching === next.isFetching &&
    prev.skeleton === next.skeleton
  )
})

export default React.memo(Board)